import { Loader } from '@linearb/linui-common';
import { StyledLoginLoader } from './StyledLoginLoader';

export function LoginLoader() {
  return (
    <StyledLoginLoader data-cy='login-loader'>
      <Loader size={72} />
    </StyledLoginLoader>
  );
}
